// Updated ProtectedRoutes component. Login-as functionality is disabled

import React, { useEffect, useState } from "react";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { routes } from "../Routes";
import SuspanceLoading from "./SuspanceLoading";
import SignupPage from "../pages/SignupPage";
import HomePage from "../pages/LandingPages/HomePage";
import ResetPassForm from "./Auth/ResetPassForm";
import NewUserPage from "../pages/LawyerPages/TeamMembers/NewUserPage";
import DashboardPage from "../pages/LawyerPages/DashboardPage";
import { allSettings } from "../pages/LawyerPages/Settings/SettingPage";
import { useAccess } from "./Auth/AccessProvider";
// import FirmAccessFoundPage from "./Auth/FirmAccessFoundPage";

import NoRoleAssignedPage from "./Auth/NoRoleAssignedPage";
import { useSelector } from "react-redux";

const ProtectedRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { userId, teamData } = useSelector((data) => data.user);
  const { getAllowedPaths, getAllowedModules, hasPathAccess, isHighAccess } =
    useAccess();
  const isAuthenticated = !!localStorage.getItem("persist:root");

  const publicPaths = [
    "/",
    "/login",
    "/request-forgot-password",
    "/request-forgot-password/verification-code",
    "/new-user/",
    "/new-user/?mail=",
  ];

// const hasAccessedLoginAs = () => {
//   return localStorage.getItem("loginAsAccessed") === "true";
// };

// const shouldShowLoginAs = () => {
//   if (!isAuthenticated || !userId) return false;
//   if (hasAccessedLoginAs()) return false;

//   return teamData && teamData.length > 0;
// };

// const canAccessLoginAs = () => {
//   if (!isAuthenticated || !userId) return false;
//   return !hasAccessedLoginAs() && teamData && teamData.length > 0;
// };

  const getAccessibleRoutes = () => {
    if (isHighAccess()) {
      return routes;
    }
    return routes.filter((route) => {
      if (!route.protected) return true;
      return hasPathAccess(route.path);
    });
  };

  const canAccessRoute = (routePath) => {
    if (publicPaths.includes(routePath)) return true;

    // if (routePath === "/login-as") {
    //   return canAccessLoginAs();
    // }

    if (routePath === "/no-role") {
      return isAuthenticated && userId;
    }

    if (routePath === "/no-role") {
      return isAuthenticated && userId;
    }

    if (isHighAccess()) return true;

    return hasPathAccess(routePath);
  };
  console.log("did you get", canAccessRoute("/dashboard/settings/*"));

  useEffect(() => {
    if (isAuthenticated && userId) {
      // const shouldShow = shouldShowLoginAs();
      // const canAccess = canAccessLoginAs();

      // if (shouldShow && location.pathname !== "/login-as") {
      //   navigate("/login-as", { replace: true });
      //   setLoading(false);
      //   return;
      // }

      // if (location.pathname === "/login-as" && !canAccess) {
      //   navigate("/dashboard", { replace: true });
      //   setLoading(false);
      //   return;
      // }

      if (
        !isHighAccess() &&
        // location.pathname !== "/login-as" &&

        location.pathname !== "/no-role" &&
        !publicPaths.includes(location.pathname) &&
        !hasPathAccess(location.pathname) &&
        location.pathname !== "/dashboard"
      ) {
        navigate("/dashboard", { replace: true });
      }
    }
    setLoading(false);
  }, [location.pathname, isAuthenticated, userId, teamData]);
  if (loading) return <SuspanceLoading />;

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<SignupPage />} />
      <Route
        path="/request-forgot-password/verification-code"
        element={<ResetPassForm />}
      />
      <Route path="/new-user/" element={<NewUserPage />} />

      {/* Settings Routes */}
      {allSettings.map(({ items }) =>
        items.map((item, index) => (
          <Route key={index} path={item.path} element={item.component()} />
        ))
      )}

      {/* Login-As Route - Special handling */}
      {/**
      <Route
        path="/login-as"
        element={
          isAuthenticated && userId && canAccessLoginAs() ? (
            <FirmAccessFoundPage />
          ) : (
            <Navigate to="/dashboard" replace />
          )
        }
      />
      */}

      <Route
        path="/no-role"
        element={
          isAuthenticated && userId ? (
            <NoRoleAssignedPage />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      <Route
        path="/no-role"
        element={
          isAuthenticated && userId ? (
            <NoRoleAssignedPage />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Dashboard Route */}
      <Route
        path="/dashboard"
        element={
          isAuthenticated && userId ? (
            <DashboardPage />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Protected Routes */}
      {getAccessibleRoutes().map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            !route.protected ||
            (isAuthenticated && userId && canAccessRoute(route.path)) ? (
              route.element
            ) : (
              <Navigate to="/dashboard" replace />
            )
          }
        />
      ))}

      {/* Catch-all Route */}
      <Route
        path="*"
        element={
          isAuthenticated && userId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
    </Routes>
  );
};

export default ProtectedRoutes;
